module.exports = __webpack_public_path__ + "img/Rich_Morris@1x.aa125e31.webp";